export { default } from './LogoSlider';
